import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../services/admin/AdminAuthServices';

/**
 * AdminProtectedRoutes
 * Decorator component to protect admin routes.
 * Redirects to login if the admin is not authenticated.
 */
const AdminProtectedRoutes = ({ children }) => {
    const { admin } = useAdminAuth();
    const location = useLocation();

    if (!admin) {
        // Redirect to login while saving the attempted location
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
};

export default AdminProtectedRoutes;
